import { useEffect, useState, useCallback } from "react";
import { logError } from "@/lib/logger";

// NOTE: We persist ONLY the non-sensitive UI theme preference ("light"/"dark")
// in localStorage. No tokens, credentials, or any sensitive data are ever stored
// client-side (the HubSpot token lives server-side only). This is safe w.r.t. XSS.
const STORAGE_KEY = "ssa-theme";

function readInitialTheme() {
  if (typeof window === "undefined") return "light";
  try {
    return localStorage.getItem(STORAGE_KEY) || "light"; // default LIGHT
  } catch (error) {
    logError("Failed to read theme preference:", error);
    return "light";
  }
}

export function useTheme() {
  const [theme, setTheme] = useState(readInitialTheme);

  useEffect(() => {
    const root = document.documentElement;
    root.classList.toggle("dark", theme === "dark");
    try {
      localStorage.setItem(STORAGE_KEY, theme);
    } catch (error) {
      // Non-fatal (e.g. private mode / storage disabled); theme still applies.
      logError("Failed to persist theme preference:", error);
    }
  }, [theme]);

  const toggle = useCallback(() => {
    setTheme((t) => (t === "dark" ? "light" : "dark"));
  }, []);

  return { theme, toggle, setTheme };
}
